import React, { useState } from 'react';
import './planSummaryCard.scss';
import ftthIcon from '../../images/ftth.svg';
import settingIcon from '../../images/mng-setting.svg';
import dedicatedIcon from '../../../../assests/dedicated-icon.png';
import KnowMore from '../knowMore/knowMore';
import { capitalizeText } from 'common/utils/app.utils';
import { getProductDisplayName } from 'common/constants/app.constants';

const PlanSummaryCard = ({
  order: {
    lead: {
      connectivityLineItems: [connectivityLineItem],
      lineItemCount,
      serviceType
    }
  }
}) => {
  const {
    planDetail,
    eligibleMedia: [availableMedia]
  } = connectivityLineItem;
  const [showKnowMoreClick, setShowKnowMoreClick] = useState(false);

  const onShowMoreClick = () => {
    setShowKnowMoreClick(!showKnowMoreClick);
  };

  const getServiceName = (serviceType) => {
    getProductDisplayName(serviceType);
  };

  return (
    <React.Fragment>
      {showKnowMoreClick && <KnowMore connectivityLineItem={connectivityLineItem} planDetail={planDetail} close={onShowMoreClick}></KnowMore>}
      <div className="plan_summary_card">
        <div className="plan_items">
          <div className="items-card">
            <div className="topcard-head">
              <img src={dedicatedIcon} className="icon-box" />
              <span className="title">{getServiceName(serviceType)}</span>
            </div>
            <div className="bottom-section">
              <div className="total-sites">
                Total Sites
                <span className="inner-value">{lineItemCount ? lineItemCount : '-'}</span>
              </div>
              <div className="total-contract-value">
                <p>Total Contract Value</p>
                <span className="inner-value"> &#8377; {planDetail ? planDetail.price.amount * (planDetail.planPeriod / 12) + planDetail.price.otc : '-'} </span>
              </div>
            </div>
            <div className="more-link">
              <span>
                <a href="javascript:void(0)" onClick={onShowMoreClick}>
                  Know More <i className="arrowright"></i>
                </a>
              </span>
            </div>

            <div className="installation-details">
              <div className="other-details">
                <div className="installation-info">
                  &#8377; {planDetail && planDetail.price.otc}
                  <span>Total Installation Fee (one-time charge)</span>
                </div>
                <div className="annual-charge">
                  &#8377; {planDetail ? planDetail.price.amount : '-'}
                  <span>Total Annual Charge (per year, ex. GST)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PlanSummaryCard;
